// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AuthenticationV2UserCreatePortalAdminUserCreatePortalAdminUserResponse {
    static getAttributeTypeMap() {
        return AuthenticationV2UserCreatePortalAdminUserCreatePortalAdminUserResponse.attributeTypeMap;
    }
}
AuthenticationV2UserCreatePortalAdminUserCreatePortalAdminUserResponse.discriminator = undefined;
AuthenticationV2UserCreatePortalAdminUserCreatePortalAdminUserResponse.additionalProperties = false;
AuthenticationV2UserCreatePortalAdminUserCreatePortalAdminUserResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "object"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
];
//# sourceMappingURL=authenticationV2UserCreatePortalAdminUserCreatePortalAdminUserResponse.js.map